import API from '@/shared/plugins/Api/API'

class SourcesV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _tagUrl (appName, tagName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}/tag/${encodeURIComponent(tagName)}`
  }

  async listRoot (appName, tagName) {
    const response = await this.request({
      method: 'get',
      url: `${this._tagUrl(appName, tagName)}/source`
    })
    return response?.files ?? response
  }

  async listFolder (appName, tagName, folderPath) {
    const url = folderPath
      ? `${this._tagUrl(appName, tagName)}/source/${folderPath}`
      : `${this._tagUrl(appName, tagName)}/source`
    const response = await this.request({
      method: 'get',
      url
    })
    return response?.files ?? response
  }

  async get (appName, tagName, filePath) {
    return this.request({
      method: 'get',
      url: `${this._tagUrl(appName, tagName)}/source/${filePath}`
    })
  }

  async update (appName, tagName, filePath, content) {
    await this.request({
      method: 'put',
      url: `${this._tagUrl(appName, tagName)}/source/${filePath}`,
      data: content,
      headers: { 'Content-Type': 'text/plain; charset=utf-8' }
    })
  }

  async delete (appName, tagName, filePath) {
    await this.request({
      method: 'delete',
      url: `${this._tagUrl(appName, tagName)}/source/${filePath}`
    })
  }

  async rename (appName, tagName, from, to) {
    await this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/source/rename`,
      data: { from, to }
    })
  }
}

export default SourcesV3
